import _classCallCheck from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, createRef } from 'react';
import debounce from 'lodash/debounce';
import { classNames } from '../../../../utilities/css.js';
import styles from './ConnectedFilterControl.scss.js';
import { Item } from './components/Item/Item.js';
import { EventListener } from '../../../EventListener/EventListener.js';
import { Button } from '../../../Button/Button.js';
import { Popover } from '../../../Popover/Popover.js';
var FILTER_FIELD_MIN_WIDTH = 150;

var ConnectedFilterControl = /*#__PURE__*/function (_Component) {
  _inherits(ConnectedFilterControl, _Component);

  var _super = _createSuper(ConnectedFilterControl);

  function ConnectedFilterControl() {
    var _this;

    _classCallCheck(this, ConnectedFilterControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      availableWidth: 0,
      proxyButtonsWidth: {}
    };
    _this.container = /*#__PURE__*/createRef();
    _this.proxyButtonContainer = /*#__PURE__*/createRef();
    _this.moreFiltersButtonContainer = /*#__PURE__*/createRef();
    _this.handleResize = debounce(function () {
      _this.measureProxyButtons();

      _this.measureAvailableWidth();
    }, 40, {
      leading: true,
      trailing: true,
      maxWait: 40
    });
    return _this;
  }

  _createClass(ConnectedFilterControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          rightPopoverableActions = _this$props.rightPopoverableActions,
          rightAction = _this$props.rightAction,
          auxiliary = _this$props.auxiliary,
          _this$props$forceShow = _this$props.forceShowMorefiltersButton,
          forceShowMorefiltersButton = _this$props$forceShow === void 0 ? true : _this$props$forceShow,
          queryFieldHidden = _this$props.queryFieldHidden;
      var actionsToRender = rightPopoverableActions != null ? this.getActionsToRender(rightPopoverableActions) : [];
      var className = classNames(styles.ConnectedFilterControl, rightPopoverableActions && styles.right);
      var shouldRenderMoreFiltersButton = forceShowMorefiltersButton || rightPopoverableActions && rightPopoverableActions.length !== actionsToRender.length;
      var RightContainerClassName = classNames(styles.RightContainer, !shouldRenderMoreFiltersButton && styles.RightContainerWithoutMoreFilters, queryFieldHidden && styles.queryFieldHidden);
      var rightMarkup = actionsToRender.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: RightContainerClassName
      }, this.popoverFrom(actionsToRender)) : null;
      var moreFiltersButtonContainerClassname = classNames(styles.MoreFiltersButtonContainer, actionsToRender.length === 0 && styles.onlyButtonVisible);
      var rightActionMarkup = rightAction ? /*#__PURE__*/React.createElement("div", {
        ref: this.moreFiltersButtonContainer,
        className: moreFiltersButtonContainerClassname
      }, shouldRenderMoreFiltersButton && /*#__PURE__*/React.createElement(Item, null, rightAction)) : null;
      var proxyButtonMarkup = rightPopoverableActions ? /*#__PURE__*/React.createElement("div", {
        className: styles.ProxyButtonContainer,
        ref: this.proxyButtonContainer,
        "aria-hidden": true
      }, rightPopoverableActions.map(function (action) {
        return /*#__PURE__*/React.createElement("div", {
          key: action.key,
          "data-key": action.key
        }, _this2.activatorButtonFrom(action, {
          proxy: true
        }));
      })) : null;
      var auxMarkup = auxiliary ? /*#__PURE__*/React.createElement("div", {
        className: styles.AuxiliaryContainer
      }, auxiliary) : null;
      return /*#__PURE__*/React.createElement(React.Fragment, null, proxyButtonMarkup, /*#__PURE__*/React.createElement("div", {
        className: styles.Wrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: this.container
      }, children ? /*#__PURE__*/React.createElement("div", {
        className: styles.CenterContainer
      }, /*#__PURE__*/React.createElement(Item, null, children)) : null, rightMarkup, rightActionMarkup, /*#__PURE__*/React.createElement(EventListener, {
        event: "resize",
        handler: this.handleResize
      })), auxMarkup));
    }
  }, {
    key: "measureProxyButtons",
    value: function measureProxyButtons() {
      if (this.proxyButtonContainer.current) {
        var proxyButtonsWidth = {}; // this number is magical, but tweaking it solved the problem of items overlapping

        var tolerance = 78;

        if (this.proxyButtonContainer.current) {
          Array.from(this.proxyButtonContainer.current.children).forEach(function (element) {
            var buttonWidth = element.getBoundingClientRect().width + tolerance;
            var buttonKey = element instanceof HTMLElement && element.dataset.key;

            if (buttonKey) {
              proxyButtonsWidth[buttonKey] = buttonWidth;
            }
          });
        }

        this.setState({
          proxyButtonsWidth: proxyButtonsWidth
        });
      }
    }
  }, {
    key: "measureAvailableWidth",
    value: function measureAvailableWidth() {
      if (this.container.current && this.moreFiltersButtonContainer.current) {
        var containerWidth = this.container.current.getBoundingClientRect().width;
        var moreFiltersButtonWidth = this.moreFiltersButtonContainer.current.getBoundingClientRect().width;
        var filtersActionWidth = 0;
        var filterFieldMinWidth = this.props.queryFieldHidden ? 0 : FILTER_FIELD_MIN_WIDTH;
        var availableWidth = containerWidth - filterFieldMinWidth - moreFiltersButtonWidth - filtersActionWidth;
        this.setState({
          availableWidth: availableWidth
        });
      }
    }
  }, {
    key: "getActionsToRender",
    value: function getActionsToRender(actions) {
      var remainingWidth = this.state.availableWidth;
      var actionsToReturn = [];

      for (var i = 0; remainingWidth > 0 && i < actions.length; i++) {
        var action = actions[i];
        var actionWidth = this.state.proxyButtonsWidth[action.key];

        if (actionWidth <= remainingWidth) {
          actionsToReturn.push(action);
          remainingWidth -= actionWidth;
        } else {
          // When we can't fit an action, we break the loop.
          // The ones that didn't fit will be accessible through the "More filters" button
          break;
        }
      }

      return actionsToReturn;
    }
  }, {
    key: "activatorButtonFrom",
    value: function activatorButtonFrom(action, options) {
      var id = options !== null && options !== void 0 && options.proxy ? undefined : "Activator-".concat(action.key);
      return /*#__PURE__*/React.createElement(Button, {
        onClick: action.onAction,
        disclosure: true,
        disabled: this.props.disabled || action.disabled,
        id: id
      }, action.content);
    }
  }, {
    key: "popoverFrom",
    value: function popoverFrom(actions) {
      var _this3 = this;

      return actions.map(function (action) {
        return /*#__PURE__*/React.createElement(Item, {
          key: action.key
        }, /*#__PURE__*/React.createElement(Popover, {
          active: action.popoverOpen,
          activator: _this3.activatorButtonFrom(action),
          onClose: action.onAction,
          preferredAlignment: "left",
          sectioned: true
        }, action.popoverContent));
      });
    }
  }]);

  return ConnectedFilterControl;
}(Component);

export { ConnectedFilterControl };